import { linksDrawerAtom } from "@design-system/atoms";
import { useChangeLocaleCode } from "@design-system/hooks";
import { ChevronIcon } from "@design-system/icons";
import { GlobeIcon } from "@design-system/icons/GlobeIcon";

export function MobileChangeLanguageButton() {
  const { changeLanguage, currentLocaleCode } = useChangeLocaleCode();

  return (
    <button
      onClick={() => {
        changeLanguage();
        linksDrawerAtom.close();
      }}
      className="flex items-center justify-between rounded-[3.6rem] bg-white bg-opacity-5 px-6 py-4"
    >
      <div className="flex items-center gap-4">
        <GlobeIcon className="h-8 w-8" />
        <span className="text-white">
          {currentLocaleCode === "en" ? "عربي" : "English"}
        </span>
      </div>
      <ChevronIcon className="-rotate-90 rtl:rotate-90" />
    </button>
  );
}
